// extracted by mini-css-extract-plugin
export default {"text":"header_text__0xFdP","title":"header_title__j5wSX","subtitle":"header_subtitle__iY0OR","image":"header_image__78PJX"};